<template>
  <PickerPane :getListMethod="getArticleListFromFilter" :locked-filters="mixedFilters" :paginationEnabled="true"
    :itemsPerPage="40" :pk="pk" ref="picker" :title="$t('servicesystem.common_objects.article.select_article')"
    :multiple="multiple" :itemValueKey="itemValueKey" :previewable="previewable" :preSelected="preSelected"
    :closeFunc="closeFunc" :closeOnSelect="closeOnSelect" @select="val => select(val)">

    <template v-slot:preview="{ item, closePreview }">
      <PreviewArticle :articleNumber="item.ArticleNumber" :closePreviewFunc="closePreview">
      </PreviewArticle>
    </template>

    <template v-slot:overlay>
      <slot name="overlay" />
    </template>

    <template v-slot:visible-filters>
      <v-row v-if="showQuickFilters" no-gutters class="mt-2 mx-1">
        <v-chip-group v-model="quickFilter" active-class="primary" mandatory>
          <v-chip small :value="null">
            {{ $t('servicesystem.common_objects.commonterms.all') }}
          </v-chip>
          <v-chip :value="'internal'" small>
            {{ $t('translate.service_articles') }}
          </v-chip>
          <v-chip :value="'model'" :disabled="!machineModelId"
            :style="!machineModelId ? 'opacity: 0.5 !important;' : ''" small>
            {{ $t('translate.commonparts') }}
          </v-chip>
          <!-- 
          <v-chip :value="'recent'" small>
            Recently used
          </v-chip>
          -->
        </v-chip-group>
      </v-row>
    </template>

    <template v-slot:list-item="{ item }">
      <ListItem :item="item" :showStoreItems="showStoreItems">
      </ListItem>
    </template>

  </PickerPane>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ListItem from "@/components/ListItems/ArticleListItem2.vue";
import PreviewArticle from "@/components/Sections/Panes/PreviewArticle.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import PickerPane from "@/views/pim/articles/PickerPane.vue";

export default {
  name: "ArticlePickerPanel",
  props: {
    lockedFilters: Object,
    preSelected: Array,
    showStoreItems: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    previewable: {
      type: Boolean,
      default: true,
    },
    pk: {
      type: String,
      default: "AL-PP-"
    },
    machineModelId: Number,
    itemValueKey: String,
    closeFunc: Function,
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    showQuickFilters: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PickerPane,
    ListItem,
    PreviewArticle,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    select(selectionFilter) {
      this.$emit("select", selectionFilter);
    },

    clearSelection() {
      this.$refs.picker.clearSelection();
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          CommonPartFromMachineModelIdList: this.modelFilter,
          OnlyInternalArticles: this.quickFilter === 'internal',
        };
        //console.log('trigger', filters)
        return filters;
      }
      else {
        return null;
      }
    },

    mixedFilters() {
      return {
        ...this.filters,
        ...this.lockedFilters
      }
    },

    quickFilter: {
      get() {
        return this.getQueryParam("filter-quick", null);
      },
      set(update) { this.setQueryParam("filter-quick", update); },
    },

    modelFilter() {
      return (this.quickFilter === "model" && this.machineModelId) ? [this.machineModelId] : null;
    },
  },

  watch: {},
};
</script>